export const translations = {
  fr: {
    nav: {
      services: "Expertises",
      method: "Méthode",
      stats: "Chiffres clés",
      contact: "Contact",
      cta: "Audit gratuit",
    },
    hero: {
      badge: "Systèmes 100% opérationnels",
      lines: [
        "L'excellence",
        "informatique, au",
        "service de votre",
        "croissance.",
      ],
      subtitle:
        "Solutions Cloud, Cybersécurité, Support de proximité et Infrastructures souveraines pour accélérer et sécuriser le développement de votre entreprise.",
      ctaPrimary: "Demander un audit gratuit",
      ctaSecondary: "Découvrir nos expertises",
      scroll: "Défiler pour explorer",
      stat1Value: "Immédiate",
      stat1Label: "Réponse du support",
      stat2Label: "Notre spécialité",
      stat2Value: "TPE & PME",
      stat3Label: "Équipe",
      stat3Value: "Ingénieurs certifiés",
    },
    marquee: [
      "Expert IT pour TPE & PME",
      "Réponse immédiate du support",
      "Cloud haute disponibilité",
      "Cybersécurité anticipative",
      "Partenaire des TPE & PME",
      "Accompagnement de proximité",
    ],
    services: {
      eyebrow: "Nos expertises",
      title: "Six pôles d'expertise.",
      titleAccent: "Une seule exigence : la vôtre.",
      subtitle:
        "Du cloud à la cybersécurité, nos ingénieurs conçoivent, déploient et supervisent l'intégralité de votre système d'information.",
      items: [
        {
          num: "01",
          title: "Solutions Cloud",
          tagline:
            "Infrastructures hybrides, migration sécurisée et hébergement souverain.",
          details: [
            "Cloud privé & public (Azure, AWS, Microsoft 365)",
            "Migration d'infrastructure sans interruption d'activité",
            "Gestion du SaaS et optimisation des coûts",
          ],
          img: "/assets/cloud-solutions-custom.png",
        },
        {
          num: "02",
          title: "Cybersécurité",
          tagline:
            "Protection 360°, surveillance continue et réponse aux incidents.",
          details: [
            "Audit de vulnérabilité & EDR/MDR managé",
            "Protection de la messagerie & sensibilisation anti-phishing",
            "Conformité RGPD et directive NIS2",
          ],
          img: "/assets/cyber-custom.png",
        },
        {
          num: "03",
          title: "Support & Infogérance",
          tagline:
            "Helpdesk de proximité, maintenance préventive et engagement de service garanti.",
          details: [
            "Support technique N1/N2/N3 en illimité",
            "Réponse immédiate à vos demandes",
            "Interventions sur site dans l'heure",
          ],
          img: "https://images.pexels.com/photos/7709148/pexels-photo-7709148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "04",
          title: "Gestion d'Identité",
          tagline:
            "Approche zéro confiance, authentification forte et gouvernance des accès.",
          details: [
            "Mise en place SSO (Single Sign-On) & MFA",
            "Administration Microsoft Entra ID / Active Directory",
            "Gouvernance des droits d'accès et traçabilité complète",
          ],
          img: "https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "05",
          title: "Sauvegarde & Continuité",
          tagline:
            "Plan de reprise d'activité (PRA/PCA) et sauvegarde immuable anti-ransomware.",
          details: [
            "Sauvegarde automatique, chiffrée et externalisée",
            "Restaurations testées périodiquement",
            "PRA Cloud à basculement rapide",
          ],
          img: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "06",
          title: "Infrastructure & Réseaux",
          tagline:
            "Architectures réseau haute performance, Wi-Fi professionnel et serveurs.",
          details: [
            "Câblage structuré & baies de brassage",
            "Pare-feu nouvelle génération & VPN sécurisés",
            "Supervision 24/7 de vos équipements",
          ],
          img: "/assets/infra-custom.png",
        },
      ],
    },
    method: {
      eyebrow: "Notre méthode",
      title: "Votre chemin vers la réussite",
      subtitle:
        "Une méthodologie éprouvée en cinq étapes, au service de la performance et de la sérénité de votre entreprise.",
      steps: [
        {
          n: "01",
          title: "Évaluation",
          desc: "Audit complet de votre infrastructure, de votre réseau et de votre environnement de travail pour un panorama détaillé de l'existant.",
        },
        {
          n: "02",
          title: "Recommandations",
          desc: "Un plan de mise en œuvre sur mesure : cartographie du réseau, objectifs clairement définis et moyens d'action recommandés.",
        },
        {
          n: "03",
          title: "Implémentation",
          desc: "Conception, gestion de projet, essais et mise en production en étroite collaboration avec vos équipes.",
        },
        {
          n: "04",
          title: "Contrôle",
          desc: "Administration à distance ou sur site de votre infrastructure, avec une vigilance permanente sur la sécurité du réseau.",
        },
        {
          n: "05",
          title: "Gestion",
          desc: "Assistance et maintenance continues, visites programmées et dépannage dans l'heure suivant votre appel.",
        },
      ],
    },
    stats: {
      eyebrow: "Chiffres clés",
      title: "La preuve par les chiffres",
      items: [
        { value: "Immédiate", label: "Réponse du support technique" },
        { value: "99,9 %", label: "Disponibilité des infrastructures supervisées" },
        { value: "+150", label: "Entreprises accompagnées" },
        { value: "1 h", label: "Délai d'intervention sur site après appel" },
      ],
    },
    partners: {
      eyebrow: "Partenaires",
      title: "Des technologies de référence, maîtrisées",
      items: [
        "Microsoft",
        "Fortinet",
        "Veeam",
        "Dell Technologies",
        "Cisco",
        "WatchGuard",
        "HP Entreprise",
        "Trend Micro",
        "D-Link",
        "Apple",
        "VMware",
      ],
    },
    hardware: {
      eyebrow: "Matériel",
      title: "Vente & location de matériel",
      subtitle:
        "PC, serveurs, écrans et périphériques : BEINTEC équipe votre entreprise toutes marques, avec livraison rapide et installation sur site. Et pour lisser votre budget, optez pour la location avec financement.",
      bullets: [
        "PC portables & fixes toutes marques (Dell, HP, Lenovo, Apple)",
        "Serveurs, NAS & équipements réseau",
        "Écrans, imprimantes & périphériques",
        "Location longue durée avec financement sur 24 ou 36 mois",
        "Livraison à J+1, installation et paramétrage sur site",
      ],
      hl1Value: "J+1",
      hl1Label: "Livraison & installation",
      hl2Value: "24/36 mois",
      hl2Label: "Location avec financement",
      cta: "Demander un devis matériel",
      img: "https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlez à un ingénieur.",
      titleAccent: "Pas à un robot.",
      subtitle:
        "Racontez-nous votre projet : un expert BEINTEC vous rappelle sous 24 h ouvrées pour en discuter, sans engagement.",
      addressLabel: "Notre adresse",
      address: "Bâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay",
      phoneLabel: "Téléphone",
      emailLabel: "Email",
      form: {
        name: "Nom complet",
        namePh: "Jean Dupont",
        company: "Société",
        companyPh: "Votre entreprise",
        email: "Email professionnel",
        emailPh: "jean@entreprise.fr",
        phone: "Téléphone",
        phonePh: "06 12 34 56 78",
        subject: "Sujet",
        message: "Votre message",
        messagePh: "Décrivez votre besoin en quelques lignes…",
        submit: "Envoyer le message",
        sending: "Envoi en cours…",
      },
      subjects: [
        "Demande d'audit gratuit",
        "Solutions Cloud",
        "Cybersécurité",
        "Support & Infogérance",
        "Gestion d'identité",
        "Sauvegarde & continuité",
        "Infrastructure & réseaux",
        "Achats de matériels",
        "Licences logiciels",
        "Autre demande",
      ],
      successTitle: "Message bien reçu !",
      successMsg:
        "Merci pour votre confiance. Un ingénieur BEINTEC vous recontacte sous 24 h ouvrées.",
      again: "Envoyer un autre message",
      error: "Une erreur est survenue. Réessayez ou appelez-nous au 01 61 12 25 39.",
    },
    footer: {
      tagline: "ESN — Faciliter votre gestion informatique",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "© 2026 BEINTEC. Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      top: "Haut de page",
    },
    legal: {
      eyebrow: "Informations réglementaires",
      title: "Mentions légales",
      updated: "Dernière mise à jour : juillet 2026",
      back: "Retour à l'accueil",
      sections: [
        {
          h: "Éditeur du site",
          p: "BEINTEC — SAS au capital de 10 000 €\nBâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay\nTéléphone : 01 61 12 25 39\nEmail : contact@beintec.com\nSIRET : 799 592 282 00047\nDirecteur de la publication : M. Jérôme Bouchet",
        },
        {
          h: "Hébergement",
          p: "Ce site est hébergé par Emergent (Emergent Labs), plateforme d'hébergement cloud accessible sur emergent.sh.",
        },
        {
          h: "Propriété intellectuelle",
          p: "L'ensemble des contenus du site (textes, logo BEINTEC, graphismes, structure) est la propriété exclusive de BEINTEC, sauf mention contraire. Toute reproduction, représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est interdite.\nLes photographies proviennent de la banque d'images Pexels (licence Pexels).",
        },
        {
          h: "Données personnelles",
          p: "Les informations recueillies via le formulaire de contact font l'objet d'un traitement décrit dans notre Politique de confidentialité, accessible depuis le pied de page.",
        },
        {
          h: "Cookies",
          p: "Ce site n'utilise pas de cookies publicitaires ni de cookies tiers de suivi. Seuls des éléments techniques strictement nécessaires au bon fonctionnement du site sont utilisés.",
        },
      ],
    },
    privacy: {
      eyebrow: "Protection des données — RGPD",
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : juillet 2026",
      back: "Retour à l'accueil",
      sections: [
        {
          h: "Responsable du traitement",
          p: "BEINTEC — Bâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay\nEmail : contact@beintec.com — Téléphone : 01 61 12 25 39",
        },
        {
          h: "Données collectées",
          p: "Via le formulaire de contact : nom, société, adresse email, numéro de téléphone, sujet et contenu de votre message. Aucune autre donnée personnelle n'est collectée à votre insu.",
        },
        {
          h: "Finalité et base légale",
          p: "Ces données sont utilisées exclusivement pour répondre à votre demande et assurer le suivi de la relation commerciale (mesures précontractuelles et intérêt légitime, article 6 du RGPD).",
        },
        {
          h: "Durée de conservation",
          p: "Vos données sont conservées au maximum 3 ans à compter de votre dernier contact avec BEINTEC, puis supprimées.",
        },
        {
          h: "Destinataires",
          p: "Vos données sont destinées exclusivement aux équipes de BEINTEC. Elles ne sont ni vendues, ni cédées, ni transférées à des tiers à des fins commerciales.",
        },
        {
          h: "Vos droits",
          p: "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez de droits d'accès, de rectification, d'effacement, d'opposition et de portabilité de vos données.\nPour les exercer : contact@beintec.com.\nVous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        },
        {
          h: "Sécurité",
          p: "BEINTEC met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès, perte ou divulgation non autorisés.",
        },
        {
          h: "Cookies",
          p: "Ce site ne dépose pas de cookies de mesure d'audience ou publicitaires soumis à consentement préalable.",
        },
      ],
    },
    cookies: {
      title: "Respect de votre vie privée",
      text: "Nous n'utilisons aucun cookie publicitaire : seuls des éléments techniques nécessaires au fonctionnement du site sont présents. Si vous acceptez, une mesure d'audience 100 % anonyme (pages vues uniquement, sans cookie ni donnée personnelle) nous aide à améliorer le site.",
      accept: "Tout accepter",
      refuse: "Refuser",
      more: "En savoir plus",
    },
  },
  en: {
    nav: {
      services: "Expertise",
      method: "Methodology",
      stats: "Key figures",
      contact: "Contact",
      cta: "Free audit",
    },
    hero: {
      badge: "Systems 100% operational",
      lines: ["IT excellence,", "engineered to", "power your", "growth."],
      subtitle:
        "Cloud solutions, cybersecurity, local support and sovereign infrastructure to accelerate and protect your company's growth.",
      ctaPrimary: "Request a free audit",
      ctaSecondary: "Explore our expertise",
      scroll: "Scroll to explore",
      stat1Value: "Immediate",
      stat1Label: "Support response",
      stat2Label: "Our specialty",
      stat2Value: "SMBs",
      stat3Label: "Team",
      stat3Value: "Certified engineers",
    },
    marquee: [
      "IT experts for SMBs",
      "Immediate support response",
      "High-availability cloud",
      "Anticipatory cybersecurity",
      "SMB & mid-market partner",
      "Local, human support",
    ],
    services: {
      eyebrow: "Our expertise",
      title: "Six areas of expertise.",
      titleAccent: "One single standard: yours.",
      subtitle:
        "From cloud to cybersecurity, our engineers design, deploy and monitor your entire information system.",
      items: [
        {
          num: "01",
          title: "Cloud Solutions",
          tagline: "Hybrid infrastructure, secure migration and sovereign hosting.",
          details: [
            "Private & public cloud (Azure, AWS, Microsoft 365)",
            "Zero-downtime infrastructure migration",
            "SaaS management & cost optimization",
          ],
          img: "/assets/cloud-solutions-custom.png",
        },
        {
          num: "02",
          title: "Cybersecurity",
          tagline: "360° protection, continuous monitoring and incident response.",
          details: [
            "Vulnerability audits & managed EDR/MDR",
            "Email protection & anti-phishing awareness",
            "GDPR and NIS2 compliance",
          ],
          img: "/assets/cyber-custom.png",
        },
        {
          num: "03",
          title: "Support & Managed Services",
          tagline: "Local helpdesk, preventive maintenance and guaranteed SLAs.",
          details: [
            "Unlimited N1/N2/N3 technical support",
            "Immediate response to your requests",
            "On-site interventions within the hour",
          ],
          img: "https://images.pexels.com/photos/7709148/pexels-photo-7709148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "04",
          title: "Identity Management",
          tagline: "Zero-trust approach, strong authentication and access governance.",
          details: [
            "SSO (Single Sign-On) & MFA implementation",
            "Microsoft Entra ID / Active Directory administration",
            "Access rights governance & full traceability",
          ],
          img: "https://images.pexels.com/photos/5473955/pexels-photo-5473955.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "05",
          title: "Backup & Continuity",
          tagline: "Disaster recovery planning (DRP/BCP) and immutable anti-ransomware backups.",
          details: [
            "Automated, encrypted, off-site backups",
            "Periodically tested restorations",
            "Cloud DRP with rapid failover",
          ],
          img: "https://images.pexels.com/photos/1148820/pexels-photo-1148820.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        },
        {
          num: "06",
          title: "Infrastructure & Networks",
          tagline: "High-performance network architecture, enterprise Wi-Fi and servers.",
          details: [
            "Structured cabling & server racks",
            "Next-generation firewalls & secure VPNs",
            "24/7 equipment monitoring",
          ],
          img: "/assets/infra-custom.png",
        },
      ],
    },
    method: {
      eyebrow: "Our methodology",
      title: "Your path to success",
      subtitle:
        "A proven five-step methodology serving your company's performance and peace of mind.",
      steps: [
        {
          n: "01",
          title: "Assessment",
          desc: "A complete audit of your infrastructure, network and work environment for a detailed picture of your existing setup.",
        },
        {
          n: "02",
          title: "Recommendations",
          desc: "A tailor-made implementation plan: network mapping, clearly defined objectives and recommended courses of action.",
        },
        {
          n: "03",
          title: "Implementation",
          desc: "Design, project management, testing and go-live in close collaboration with your teams.",
        },
        {
          n: "04",
          title: "Control",
          desc: "Remote or on-site administration of your infrastructure, with constant vigilance over network security.",
        },
        {
          n: "05",
          title: "Management",
          desc: "Ongoing support and maintenance, scheduled visits and troubleshooting within the hour of your call.",
        },
      ],
    },
    stats: {
      eyebrow: "Key figures",
      title: "Proof in numbers",
      items: [
        { value: "Immediate", label: "Technical support response" },
        { value: "99.9%", label: "Monitored infrastructure uptime" },
        { value: "+150", label: "Companies supported" },
        { value: "1 h", label: "On-site intervention delay after call" },
      ],
    },
    partners: {
      eyebrow: "Partners",
      title: "Best-in-class technologies, mastered",
      items: [
        "Microsoft",
        "Fortinet",
        "Veeam",
        "Dell Technologies",
        "Cisco",
        "WatchGuard",
        "HP Entreprise",
        "Trend Micro",
        "D-Link",
        "Apple",
        "VMware",
      ],
    },
    hardware: {
      eyebrow: "Hardware",
      title: "Hardware sales & leasing",
      subtitle:
        "PCs, servers, monitors and peripherals: BEINTEC equips your company with all brands, with fast delivery and on-site installation. And to smooth your budget, choose leasing with financing.",
      bullets: [
        "Laptops & desktops, all brands (Dell, HP, Lenovo, Apple)",
        "Servers, NAS & network equipment",
        "Monitors, printers & peripherals",
        "Long-term leasing with 24 or 36-month financing",
        "Next-day delivery, on-site installation and setup",
      ],
      hl1Value: "D+1",
      hl1Label: "Delivery & installation",
      hl2Value: "24/36 months",
      hl2Label: "Leasing with financing",
      cta: "Request a hardware quote",
      img: "https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    contact: {
      eyebrow: "Contact",
      title: "Talk to an engineer.",
      titleAccent: "Not a bot.",
      subtitle:
        "Tell us about your project: a BEINTEC expert will call you back within one business day, with no commitment.",
      addressLabel: "Our address",
      address: "Bâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay, France",
      phoneLabel: "Phone",
      emailLabel: "Email",
      form: {
        name: "Full name",
        namePh: "John Smith",
        company: "Company",
        companyPh: "Your company",
        email: "Work email",
        emailPh: "john@company.com",
        phone: "Phone",
        phonePh: "+33 6 12 34 56 78",
        subject: "Subject",
        message: "Your message",
        messagePh: "Describe your needs in a few lines…",
        submit: "Send message",
        sending: "Sending…",
      },
      subjects: [
        "Free audit request",
        "Cloud solutions",
        "Cybersecurity",
        "Support & managed services",
        "Identity management",
        "Backup & continuity",
        "Infrastructure & networks",
        "Hardware purchase",
        "Software licenses",
        "Other request",
      ],
      successTitle: "Message received!",
      successMsg:
        "Thank you for your trust. A BEINTEC engineer will get back to you within one business day.",
      again: "Send another message",
      error: "Something went wrong. Please try again or call us at +33 1 61 12 25 39.",
    },
    footer: {
      tagline: "IT services company — Making IT management simple",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "© 2026 BEINTEC. All rights reserved.",
      legal: "Legal notice",
      privacy: "Privacy policy",
      top: "Back to top",
    },
    legal: {
      eyebrow: "Regulatory information",
      title: "Legal Notice",
      updated: "Last updated: July 2026",
      back: "Back to home",
      sections: [
        {
          h: "Website publisher",
          p: "BEINTEC — SAS (simplified joint-stock company), share capital: €10,000\nBâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay, France\nPhone: +33 1 61 12 25 39\nEmail: contact@beintec.com\nSIRET (company registration): 799 592 282 00047\nPublication director: Mr Jérôme Bouchet",
        },
        {
          h: "Hosting",
          p: "This website is hosted by Emergent (Emergent Labs), a cloud hosting platform available at emergent.sh.",
        },
        {
          h: "Intellectual property",
          p: "All content on this site (texts, BEINTEC logo, graphics, structure) is the exclusive property of BEINTEC unless otherwise stated. Any reproduction, representation or distribution, in whole or in part, without prior written authorization is prohibited.\nPhotographs are sourced from the Pexels image library (Pexels license).",
        },
        {
          h: "Personal data",
          p: "Information collected through the contact form is processed as described in our Privacy Policy, available from the footer.",
        },
        {
          h: "Cookies",
          p: "This site does not use advertising cookies or third-party tracking cookies. Only technical elements strictly necessary for the proper functioning of the site are used.",
        },
      ],
    },
    privacy: {
      eyebrow: "Data protection — GDPR",
      title: "Privacy Policy",
      updated: "Last updated: July 2026",
      back: "Back to home",
      sections: [
        {
          h: "Data controller",
          p: "BEINTEC — Bâtiment Astra, 8-10 rue Nieuport, 78140 Vélizy-Villacoublay, France\nEmail: contact@beintec.com — Phone: +33 1 61 12 25 39",
        },
        {
          h: "Data collected",
          p: "Through the contact form: name, company, email address, phone number, subject and content of your message. No other personal data is collected without your knowledge.",
        },
        {
          h: "Purpose and legal basis",
          p: "This data is used exclusively to respond to your request and to follow up on the business relationship (pre-contractual measures and legitimate interest, Article 6 of the GDPR).",
        },
        {
          h: "Retention period",
          p: "Your data is kept for a maximum of 3 years from your last contact with BEINTEC, then deleted.",
        },
        {
          h: "Recipients",
          p: "Your data is intended exclusively for BEINTEC teams. It is never sold, transferred or shared with third parties for commercial purposes.",
        },
        {
          h: "Your rights",
          p: "In accordance with the GDPR and the French Data Protection Act, you have the rights of access, rectification, erasure, objection and portability of your data.\nTo exercise them: contact@beintec.com.\nYou may also lodge a complaint with the CNIL (www.cnil.fr).",
        },
        {
          h: "Security",
          p: "BEINTEC implements appropriate technical and organizational measures to protect your data against unauthorized access, loss or disclosure.",
        },
        {
          h: "Cookies",
          p: "This site does not set any audience measurement or advertising cookies subject to prior consent.",
        },
      ],
    },
    cookies: {
      title: "Your privacy matters",
      text: "We do not use any advertising cookies: only technical elements required for the site to function are present. If you accept, 100% anonymous audience measurement (page views only, no cookies or personal data) helps us improve the site.",
      accept: "Accept all",
      refuse: "Refuse",
      more: "Learn more",
    },
  },
};
